// extracted by mini-css-extract-plugin
module.exports = {"AdminDataStores":"AdminDataStores_twQCe"};